// Google Analytics 4 (gtag.js) integration.
// No-ops entirely when REACT_APP_GA_MEASUREMENT_ID isn't set (e.g. local dev).

const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

let initialized = false;

/** Injects gtag.js and configures GA4. Call once at app startup. */
export function initGA() {
  if (!GA_MEASUREMENT_ID || initialized) return;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;

  gtag('js', new Date());
  // send_page_view disabled here — we send page_view manually on route change
  // instead, since GA's automatic pageview fires before React Router mounts.
  gtag('config', GA_MEASUREMENT_ID, { send_page_view: false });

  initialized = true;
}

/** Sends a GA4 page_view event for the given path. Call on every route change. */
export function trackPageview(path) {
  if (!GA_MEASUREMENT_ID || typeof window.gtag !== 'function') return;
  window.gtag('event', 'page_view', { page_path: path });
}
